import React from 'react';
import { LayoutDashboardIcon, MegaphoneIcon, InboxIcon, TruckIcon, CreditCardIcon, GaugeIcon, LifeBuoyIcon, UserIcon, BrainCircuitIcon, SettingsIcon, FileCheckIcon, DumbbellIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface SidebarProps {
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
}
export function Sidebar({
  activeTab = 'bciti',
  onTabChange
}: SidebarProps) {
  const {
    t
  } = useLanguage();
  const menuItems = [{
    id: 'bciti-id',
    icon: CreditCardIcon,
    label: 'ID'
  }, {
    id: 'bciti',
    icon: MegaphoneIcon,
    label: 'Communications'
  }, {
    id: 'requetes',
    icon: InboxIcon,
    label: 'Requêtes'
  }, {
    id: 'permis',
    icon: FileCheckIcon,
    label: 'Permis'
  }, {
    id: 'loisirs',
    icon: DumbbellIcon,
    label: 'Loisirs'
  }, {
    id: 'collectes',
    icon: TruckIcon,
    label: 'Collectes'
  }, {
    id: 'compteurs',
    icon: GaugeIcon,
    label: 'Compteurs'
  }, {
    id: 'atna',
    icon: BrainCircuitIcon,
    label: 'ATNA AI'
  }, {
    id: 'settings',
    icon: SettingsIcon,
    label: 'Paramètres'
  }];
  return <aside className="w-64 bg-white border-r border-slate-200 hidden lg:flex flex-col h-full" data-id="element-6320" data-mp="1h0ayushlww3h">
      <nav className="flex-1 py-6 px-4 space-y-1.5" data-id="element-6321" data-mp="24q570wqzdwhe">
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return <button key={item.id} onClick={() => onTabChange?.(item.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-[#0F172A] text-white shadow-sm' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'}`} data-id="element-6322" data-mp="1vpgwic0sqe99">
              <Icon className={`w-5 h-5 ${isActive ? 'text-[#4F46E5]' : 'text-slate-400'}`} data-id="element-6323" data-mp="pafubol6gzu8" />
              {item.label}
            </button>;
      })}
      </nav>

      <div className="p-4 border-t border-slate-200" data-id="element-6324" data-mp="2m0sd6q020gvw">
        <div className="bg-slate-50 p-4 rounded-lg border border-slate-200" data-id="element-6325" data-mp="2h8r4fe23h8am">
          <div className="flex items-center gap-2 mb-2" data-id="element-6326" data-mp="2h6o4o2b540sp">
            <LifeBuoyIcon className="w-4 h-4 text-slate-500" data-id="element-6327" data-mp="2d64b18przfbb" />
            <p className="text-xs font-semibold text-slate-600 uppercase tracking-wider" data-id="element-6328" data-mp="2882naahemrti">
              {t('Support', 'Support')}
            </p>
          </div>
          <p className="text-xs text-slate-500 mb-3 leading-relaxed" data-id="element-6329" data-mp="237ogevrjhnx2">
            {t('Besoin d’aide avec le système de géorepérage ?', 'Need help with the geofencing system?')}
          </p>
          <button className="text-sm text-[#4F46E5] font-medium hover:text-[#4338CA] transition-colors" data-id="element-6330" data-mp="3snxleh2vweqb">
            {t('Contacter le support', 'Contact support')}
          </button>
        </div>
      </div>
    </aside>;
}